/**
 * Driver Performance Dashboard
 */

import {
    driversActionColumns,
    rootCauseColumns,
    complianceBreakdownColumns,
    monthComparisonColumns
} from './columns'

// ---------- Design tokens ----------
export const COLORS = {
    bg: "#eef1f8",
    sidebar: "#0e1a3d",
    navy: "#0e1a3d",
    red: "#e11d48",
    redBg: "#fdeceb",
    orange: "#f2994a",
    orangeBg: "#fff4e0",
    amber: "#f5a623",
    amberBg: "#fff7e0",
    green: "#16a34a",
    greenBg: "#eafaf0",
    greenLight: "#4ade80",
    blue: "#2563eb",
    blueBg: "#eaf1fe",
    gray: "#64748b",
    grayBg: "#eef1f5",
    textMuted: "#6b7280",
    border: "#e7e9f2",
};

export const GRADE_COLORS = {
    A: COLORS.green,
    B: COLORS.greenLight,
    C: COLORS.amber,
    D: COLORS.orange,
    E: COLORS.red,
};


export const CONCLUSION_STATUS = {
    WORSE: -1,
    IMPROVED: 1,
    NO_CHANGE: 0
}

export const CONCLUSION_STATUS_INDEX = {
    [CONCLUSION_STATUS.WORSE]: {
        label: 'Worse',
        color: 'red'
    },
    [CONCLUSION_STATUS.IMPROVED]: {
        label: 'Improved',
        color: 'green'
    },
    [CONCLUSION_STATUS.NO_CHANGE]: {
        label: 'No Change',
        color: 'orange'
    },
}

export const conclusionStatus = (value) => {
    if(value > 0) return 1
    else if(value < 0) return -1
    else return 0
}

export const improvementStatus = (prev, next) => {
    const sum = next - prev

    let action = false
    let color = 'default'

    if(sum > 0) color = 'success'
    else if(sum < 0) color = 'error'; action = true

    return color === 'default' ? null : { text: sum, color, action }
}

export const colorClassification = (score = 30, fullScore = 55, tag = false) => {

    const classified = fullScore / 3

    if(score <= (classified * 1)) {
        return tag ? 'error' : COLORS.red
    }
    else if(score <= (classified * 2)) {
        return tag ? 'warning' : COLORS.orange
    }
    else if(score <= (classified * 3)) {
        return tag ? 'success' : COLORS.green
    }
    else return
}

export const fleetRiskIndex = (score) => {
    let text = 'NONE'
    let color = COLORS.textMuted

    if(score > 80) {
        text = 'LOW'; color = COLORS.greenBg;
    }
    else if(score > 55) {
        text = 'NORMAL'; color = COLORS.textMuted;
    }
    else {
        text = 'HIGH'; color = COLORS.red;
    }

    return { text, color }
}

// A >85, B 75–85, C 65–75, D 55–65, E <55
export const driverScoreGenerator = (score) => {
    if(score >= 85) return 'A'
    else if(score >= 75) return 'B'
    else if(score >= 65) return 'C'
    else if(score >= 55) return 'D'
    else return 'E'
}

export const calculateGradeDistribution = (data = []) => {

    const gradeCount = { A: 0, B: 0, C: 0, D: 0, E: 0 };
    
    data.forEach(item => {
        const grade = driverScoreGenerator(item.score);
        gradeCount[grade]++;
    });
    
    return Object.entries(gradeCount).map(([grade, count]) => ({
        grade,
        count
    }));
};



export {
    driversActionColumns,
    rootCauseColumns,
    complianceBreakdownColumns,
    monthComparisonColumns
}